<template>
  <v-card
    class="font-selector"
    elevation="2"
  >
    <v-card-title>
      <h3>{{ title }}</h3>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <v-row>
            <!-- <v-col
              cols="12"
              sm="6"
            >
              <span style="font-size: 14px; margin-bottom: 5px;">字体</span>
              <v-select
                v-model="selectedFont"
                :items="availableFonts"
                outlined
                dense
                @change="applyFont"
              />
            </v-col> -->

            <v-col
              cols="12"
              sm="6"
            >
              <span style="font-size: 14px; margin-bottom: 5px;">字号 {{ formData.size }}</span>
              <v-slider
                v-model="formData.size"
                min="8"
                max="72"
                step="1"
                thumb-label
                class="mt-2"
                @change="applyFont"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <span style="font-size: 14px; margin-bottom: 5px;">颜色 </span>
              <v-menu
                :close-on-content-click="false"
                bottom
                offset-overflow
                transition="slide-y-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <div
                    style="
                      height: 30px;
                      margin-top: 5px;
                      border: 1px solid #9E9E9E;
                      cursor: pointer;
                      width: 30px;
                      border-radius: 50%;
                      "
                    color="primary"
                    :style="{background:formData.color||'#fff',}"
                    v-on="on"
                  />
                </template>
                <v-color-picker
                  v-model="formData.color"
                  class="ma-2"
                  dot-size="30"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="12"
          sm="6"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
            >
              <span style="font-size: 14px; margin-bottom: 5px;">文字</span>
              <!-- <v-text-field
                class="preview-box pa-2"
                :style="previewStyle"
                :height="fontSize+20"
              >
                <span style="padding: 10px 0;">
                  {{ previewText }}
                </span>
              </v-text-field> -->
              <input
                v-model="formData.name"
                :style="previewStyle"
                style="display: block;
                min-height: 40px;
                border: 1px solid #9e9e9e;
                padding: 0 10px;
                width: 100%;
                "
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FontSelector',

  props: {
    // 初始字体设置
    initialFont: {
      type: Object,
      default: () => ({
        family: 'Arial',
        size: 16,
        bold: false,
        italic: false,
        underline: false
      })
    },
    title: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => ({
        name: '',
        font: 'Arial',
        size: '16',
        color: ''
      })
    }
  },
  data() {
    return {
      availableFonts: [
        'Arial',
        'Times New Roman',
        'Courier New',
        'Georgia',
        'Verdana',
        '宋体',
        '微软雅黑',
        '黑体',
        '楷体',
        '仿宋',
        '方正舒体',
        '方正姚体'
      ],
      selectedFont: this.initialFont.family,
      fontSize: this.initialFont.size,
      isBold: this.initialFont.bold,
      isItalic: this.initialFont.italic,
      isUnderline: this.initialFont.underline,
      previewText: ''
    }
  },
  computed: {
    previewStyle() {
      return {
        fontFamily: this.formData.font,
        fontSize: `${this.formData.size}px`,
        // fontWeight: this.isBold ? 'bold' : 'normal',
        // fontStyle: this.isItalic ? 'italic' : 'normal',
        borderRadius: '4px',
        color: this.formData.color || '#000'
      }
    },
    currentFont() {
      return {
        family: this.selectedFont,
        size: this.fontSize,
        bold: this.isBold,
        italic: this.isItalic,
        underline: this.isUnderline
      }
    }
  },
  methods: {
    applyFont() {
      // 实时应用字体更改到预览
      this.$emit('font-change', this.currentFont)
    },
    confirmSelection() {
      // 确认选择并传递当前字体设置
      this.$emit('font-selected', this.currentFont)
    },
    resetSelection() {
      // 重置为初始值
      this.selectedFont = this.initialFont.family
      this.fontSize = this.initialFont.size
      this.isBold = this.initialFont.bold
      this.isItalic = this.initialFont.italic
      this.isUnderline = this.initialFont.underline
      this.applyFont()
    },
    getFormData() {
      return this.formData
    }
  }
}
</script>

<style scoped>
.font-selector {
  /* width: 50%; */
  height: 180px;
}

.preview-box {
  /* min-height: 100px; */
  transition: all 0.3s ease;
}
.v-input__slot {
  margin-bottom: 0;
}
</style>
